"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressStepperCurrentLabel = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ProgressStepperCurrentLabelMixin = require("../../mixins/components/ProgressStepperCurrentLabelMixin");
var _ProgressStepperStepLabel = require("../ProgressStepperStepLabel/ProgressStepperStepLabel");
/**
 * Used by `ProgressStepper` when only showing the label for the current step.
 *
 * It's the same as a `ProgressStepperStepLabel` but a separate component so that
 * `ProgressStepper` can control its visibility separately.
 *
 * @extends ProgressStepperStepLabel
 * @since 8.57.0
 */
var ProgressStepperCurrentLabel = /*#__PURE__*/(0, _styledComponents.default)(_ProgressStepperStepLabel.ProgressStepperStepLabel).withConfig({
  displayName: "ProgressStepperCurrentLabel",
  componentId: "c11n-8-109-1__sc-6abryx-0"
})(["", ""], _ProgressStepperCurrentLabelMixin.ProgressStepperCurrentLabelMixin);
exports.ProgressStepperCurrentLabel = ProgressStepperCurrentLabel;
ProgressStepperCurrentLabel.displayName = 'ProgressStepperCurrentLabel';

/** @component */